var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.345 13.3298L13.7967 4.87816L12.6183 3.69982L4.16667 12.1515V13.3298H5.345ZM6.03583 14.9965H2.5V11.4607L12.0292 1.93149C12.1854 1.77526 12.3974 1.6875 12.6183 1.6875C12.8393 1.6875 13.0512 1.77526 13.2075 1.93149L15.565 4.28899C15.7212 4.44526 15.809 4.65719 15.809 4.87816C15.809 5.09913 15.7212 5.31105 15.565 5.46732L6.03583 14.9965V14.9965ZM2.5 16.6632H17.5V18.3298H2.5V16.6632Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenEdit);
export default __webpack_public_path__ + "static/media/pen_edit.51da51aa120fe89065ede7ab7176628d.svg";
export { ForwardRef as ReactComponent };